export default __webpack_public_path__ + "static/media/laptop_mob_1.50ec8457.png";